// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_ac-0";
export var optionCard = "_ac-1";